import { AxiosResponse } from 'axios';
import { Inject, Service } from 'vue-di-container';
import { CheckMortgageOTPResponse } from '../models/models';
import AxiosService from './AxiosService';
import GStatic from './GStatic';
import LoaderService from './LoaderService';

@Service()
export default class MortgagesService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async GetAll(filter: any, pageIndex: number = 1) {
        const url = 'api/v1/getAll';
        const query = '?' + GStatic.toQueryString(filter);
        //console.log("whats happenning: ",query);
        this.loaderService.ShowLoader();
        const result = await this.axiosService.axiosInstance.post(url, filter);

        this.loaderService.HideLoader();
        return result.data;
    }


    public async GetAllData(filter: any, pageIndex: number = 1) {
        const url = 'api/v1/getAlldata';
        const query = '?' + GStatic.toQueryString(filter);
        console.log(url + query);
        this.loaderService.ShowLoader();
        const result = await this.axiosService.axiosInstance.post(url + query);
        this.loaderService.HideLoader();
        return result.data;
    }

    public async verifiedcheckmortgagedocument(data: any) {
        const url = 'api/v1/checkmortgagedocument';

        this.loaderService.ShowLoader();
        const result = await this.axiosService.axiosInstance.post(url, data);
        this.loaderService.HideLoader();
        return result.data;
    }

    public async GetMortgages(id: number) {//details
        try {
            debugger
            const url = 'api/v1/Mortgages/' + id.toString();
            this.loaderService.ShowLoader();
            const result = await this.axiosService.axiosInstance.post(url);
            return result.data;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async GetSarchData(data: any) {//details
        try {

            const url = 'api/v1/getAlldata/';
            this.loaderService.ShowLoader();
            const result = await this.axiosService.axiosInstance.post(url, data);
            return result.data;
        } catch (error) {

        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async CancellationReasons() {//details
        try {
            const url = 'api/v1/CancellationReasons';

            this.loaderService.ShowLoader();
            const result = await this.axiosService.axiosInstance.get(url);
            //this.check320(result);
            this.loaderService.HideLoader();

            //console.log("camcel reasons: ", result.data);

            return result.data;
        } catch (error) {

            this.onCatch(error);
        }
    }

    public async NafathGenerateOtp(request: any) {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/NafathGenerateOtp';

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            const result = await this.axiosService.axiosInstance.post(url, JSON.stringify(request), config);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }


    public async GenerateOtp(request: any) {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/GenerateOtp';

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            const result = await this.axiosService.axiosInstance.post(url, JSON.stringify(request), config);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async VerifyOTP(data: any) {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/v1/verifyOtp';

            const result = await this.axiosService.axiosInstance.post(url, data);
            return result.data ? result.data : undefined;
        } catch (error) {
            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }

    }
    public async NafathVerifyOTP(data: any) {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/v1/nafathverifyOtp';

            const result = await this.axiosService.axiosInstance.post(url, data);
            return result.data ? result.data : undefined;
        } catch (error) {
            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }

    }

    public async verifyInternal(data: any) {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/v1/verifyInternal';

            const result = await this.axiosService.axiosInstance.post(url, data);
            return result.data ? result.data : undefined;
        }
        catch (error) {
            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async IsNajizUser() {//
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/isNajiz';

            const result = await this.axiosService.axiosInstance.get(url);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async checkIfUserFromNajiz() {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/checkIfUserFromNajiz';

            const result = await this.axiosService.axiosInstance.post(url);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async ApproveByNajiz(data: any) {//ارسل بيانات المستخدم بدون id Or key
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/apprveNajizMortgages';
            console.log(data);

            const result = await this.axiosService.axiosInstance.post(url, data);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async rejectMortgages(data: any) {
        this.loaderService.ShowLoader();
        try {
            const url = 'api/v1/rejectMortgages/' + data;
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async DocumentDetails(data: string) {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/DocumentDetails/' + data;
            const result = await this.axiosService.axiosInstance.post(url);

            return result.data ? result.data : undefined;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }


    public onCatch(error: any) {
        GStatic.log('onCatch', error);
    }

    public check320(result: any) {
        GStatic.log('result', result);
        if (result && result.status === 320) {
            GStatic.log('check320', result.status);
            alert('check320');
        }
    }


    public async nafathverifyExtarnal(data: any): Promise<any> {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/nafathverifyExtarnal/';
            const result = await this.axiosService.axiosInstance.post<any>(url, data);

            if (result.status != 200 || 'error' in (result.data as any))
                return null as any;

            return result.data;
        } catch (error) {
            return null as any;
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async verifyExtarnal(data: any): Promise<any> {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/verifyExtarnal/';
            const result = await this.axiosService.axiosInstance.post<any>(url, data);

            if (result.status != 200 || 'error' in (result.data as any))
                return null as any;

            return result.data;
        } catch (error) {
            return null as any;
        }
        finally {
            this.loaderService.HideLoader();
        }
    }
    //public async nafathloadDocumentData(data: any): Promise<any> {
    //    try {
    //        this.loaderService.ShowLoader();
    //        const url = 'api/v1/NafathLoadDocumentData';
    //        const result = await this.axiosService.axiosInstance.post<any>(url, data);
    //        console.log(result, "NafathLoadDocumentData");

    //        if (result.status != 200 || 'error' in (result.data as any))
    //            return null as any;

    //        return result.data;
    //    } catch (error) {
    //        return null as any;
    //    }
    //    finally {
    //        this.loaderService.HideLoader();
    //    }
    //}

    public async nafathloadDocumentData(data: any): Promise<any> {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/NafathLoadDocumentData';
            const result = await this.axiosService.axiosInstance.post<any>(url, data);

            if (result.status != 200 || 'error' in (result.data as any))
                return null as any;

            return result.data;
        } catch (error) {
            return null as any;
        }
        finally {
            this.loaderService.HideLoader();
        }
    }


    public async loadDocumentData(data: any): Promise<any> {
        try {
            this.loaderService.ShowLoader();
            const url = 'api/v1/LoadDocumentData';
            const result = await this.axiosService.axiosInstance.post<any>(url, data);

            if (result.status != 200 || 'error' in (result.data as any))
                return null as any;

            return result.data;
        } catch (error) {
            return null as any;
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async GetMortgageById(id: number, type: number) {
        try {
            const url = `api/v1/Mortgage/${id.toString()}/${type.toString()}`;
            this.loaderService.ShowLoader();
            const result = await this.axiosService.axiosInstance.post(url, type.toString());
            return [result.data.item1, result.data.item2];
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }

    public async DawnLodePDF(documentNumber: any) {
        try {
            const url = 'api/v1/DawnLodePDF?docNo=' + documentNumber;
            this.loaderService.ShowLoader();
            //const result = await this.axiosService.axiosInstance.get(url);

            await this.axiosService.axiosInstance.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = documentNumber + '.pdf';
                    link.click();
                    URL.revokeObjectURL(link.href);
                }).catch(console.error);

            //return result.data;
        } catch (error) {

            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }
    public async GetMortgageByIdAndKey(EId: string, EKey: string, type: any) {
        try {
            const url = 'api/v1/MortgageDataExt';
            this.loaderService.ShowLoader();
            const result = await this.axiosService.axiosInstance.post(url, { encId: EId, encKey: EKey, encType: type });
            return result.data;
        } catch (error) {
            this.onCatch(error);
        }
        finally {
            this.loaderService.HideLoader();
        }
    }


    public async GetUniqueIdentifier() {
        try {
            const url = 'api/v1/GetUniqueIdentifier';
            const result = await this.axiosService.axiosInstance.get(url);

            return result.data;
        } catch (error) {

            this.onCatch(error);
        }
    }



    public async GetQaimSettings() {
        try {
            const url = 'api/v1/GetQaimSettings';
            debugger
            const result = await this.axiosService.axiosInstance.get(url);
            debugger
            return result.data;
        } catch (error) {

            this.onCatch(error);
        }
    }

    public async GetNafathSettings() {
        try {
            const url = 'api/v1/GetNafathSettings';
            debugger
            const result = await this.axiosService.axiosInstance.get(url);
            debugger
            return result.data;
        } catch (error) {

            this.onCatch(error);
        }
    }






}
